export enum RecruiterDetailSection {
  PrimaryInfo = 'primary',
  AdditionalInfo = 'additional',
}
